import { render, staticRenderFns } from "./FileUploadUndo.vue?vue&type=template&id=cb5c89a0&"
import script from "./FileUploadUndo.vue?vue&type=script&lang=js&"
export * from "./FileUploadUndo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports